import React from "react";
import styles from "./SiteStatusChip.module.scss";

export const SiteStatusChip = ({status}) => {
  if (!status) {
    return null;
  }

  const statusColor = status.color.split("|");

  return <span className={styles.status} style={{backgroundColor: statusColor[0], color: statusColor[1]}}>
    {status.name}
  </span>;
};
